function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isBlank } from "imagica-corekit/dist/base/cutil/Extensions";
import { ChainResultInitCreateBlobUrl, ChainResultTextAreaValue } from "imagica-corekit/dist/base/storyV2/response/customApiHandler/chain/ChainRequest";
import { CpCofig } from "./ViewBuilderCpWrapper";
export var Props = /*#__PURE__*/_createClass(function Props() {
  _classCallCheck(this, Props);
  _defineProperty(this, "item", new DomObject());
  _defineProperty(this, "isInCanvas", false);
  _defineProperty(this, "setNodes", function () {});
  _defineProperty(this, "readonlyStyle", "");
});
export var DomObject = /*#__PURE__*/_createClass(function DomObject() {
  _classCallCheck(this, DomObject);
  _defineProperty(this, "type", "");
  _defineProperty(this, "imgKey", "");
  _defineProperty(this, "audio", new ViewBuilderAudio());
  _defineProperty(this, "mapData", new MapData());
  _defineProperty(this, "head", "");
  _defineProperty(this, "paragraph", "");
  _defineProperty(this, "lis", []);
});
export var ViewBuilderAudio = /*#__PURE__*/_createClass(function ViewBuilderAudio() {
  _classCallCheck(this, ViewBuilderAudio);
  _defineProperty(this, "initCreateBlobUrl", new ChainResultInitCreateBlobUrl());
  _defineProperty(this, "textAreaValue", new ChainResultTextAreaValue());
});
var MapData = /*#__PURE__*/_createClass(function MapData() {
  _classCallCheck(this, MapData);
  _defineProperty(this, "mapKey", "");
  _defineProperty(this, "startLocation", new LocationData());
  _defineProperty(this, "endLocation", new LocationData());
});
var LocationData = /*#__PURE__*/_createClass(function LocationData() {
  _classCallCheck(this, LocationData);
  _defineProperty(this, "address", "");
  _defineProperty(this, "latlng", []);
});
export var ScreenItem = /*#__PURE__*/_createClass(function ScreenItem() {
  _classCallCheck(this, ScreenItem);
  _defineProperty(this, "tabName", "");
  // @Type(() => DomObject)
  _defineProperty(this, "screenInfo", []);
});
var parser = new DOMParser();
export var ViewBuilderCpWrapperUtil = /*#__PURE__*/function () {
  function ViewBuilderCpWrapperUtil() {
    _classCallCheck(this, ViewBuilderCpWrapperUtil);
  }
  _createClass(ViewBuilderCpWrapperUtil, null, [{
    key: "parseStrToObject",
    value: function parseStrToObject(inputString) {
      inputString = inputString.replaceAll("&", "&amp;");
      var xmlDoc = parser.parseFromString(inputString, "text/xml");

      // 获取所有的 <screen> 标签
      var screens = xmlDoc.querySelectorAll("screen");
      var result = [];

      // 遍历每个 <screen> 标签
      screens.forEach(function (screen) {
        var tabName = screen.getAttribute("tab_name") || "";
        var contentDivs = screen.querySelectorAll("div");
        var screenInfo = [];

        // 遍历每个 <div> 标签
        contentDivs.forEach(function (contentDiv) {
          var _contentDiv$querySele, _contentDiv$querySele2, _contentDiv$querySele3, _contentDiv$querySele4;
          var type = contentDiv.getAttribute("id") || "";
          var imgKey = ((_contentDiv$querySele = contentDiv.querySelector("img")) === null || _contentDiv$querySele === void 0 ? void 0 : _contentDiv$querySele.getAttribute("src")) || "";
          var mapKey = ((_contentDiv$querySele2 = contentDiv.querySelector("map")) === null || _contentDiv$querySele2 === void 0 ? void 0 : _contentDiv$querySele2.getAttribute("src")) || "";
          var head = ((_contentDiv$querySele3 = contentDiv.querySelector("h")) === null || _contentDiv$querySele3 === void 0 ? void 0 : _contentDiv$querySele3.textContent) || "";
          var paragraph = ((_contentDiv$querySele4 = contentDiv.querySelector("p")) === null || _contentDiv$querySele4 === void 0 ? void 0 : _contentDiv$querySele4.textContent) || "";
          var lis = Array.from(contentDiv.querySelectorAll("li")).map(function (li) {
            return li.textContent || "";
          }).filter(function (li) {
            return !isBlank(li);
          });

          // 将当前 <div> 下的信息存储为子数组
          screenInfo.push({
            type: type,
            imgKey: imgKey,
            audio: type === "audio" ? new ViewBuilderAudio() : undefined,
            mapData: {
              mapKey: mapKey,
              startLocation: new LocationData(),
              endLocation: new LocationData()
            },
            head: head,
            paragraph: paragraph,
            lis: lis
          });
        });

        // 将当前 <screen> 下的所有 <div> 信息存储为子数组
        result.push({
          tabName: tabName,
          screenInfo: screenInfo
        });
      });
      var filterRes = result.map(function (x) {
        var filterScreenInfo = x.screenInfo.filter(ViewBuilderCpWrapperUtil.filterCondition);
        return _objectSpread(_objectSpread({}, x), {}, {
          screenInfo: filterScreenInfo
        });
      }).filter(function (x) {
        return !isBlank(x.screenInfo);
      });
      return filterRes;
    }
  }, {
    key: "filterCondition",
    value: function filterCondition(y) {
      var isSupportType = ViewBuilderCpWrapperUtil.isSupportType(y);
      var notEmptyText = ViewBuilderCpWrapperUtil.notEmptyText(y);
      var notEmptyMap = ViewBuilderCpWrapperUtil.notEmptyMap(y);
      var notEmptyImage = ViewBuilderCpWrapperUtil.notEmptyImage(y);
      var notEmptyList = ViewBuilderCpWrapperUtil.notEmptyList(y);
      return isSupportType && notEmptyText && notEmptyMap && notEmptyImage && notEmptyList;
    }
  }, {
    key: "isSupportType",
    value: function isSupportType(y) {
      return !isBlank(y.type) && Object.keys(CpCofig).some(function (z) {
        return z === y.type;
      });
    }
  }, {
    key: "notEmptyText",
    value: function notEmptyText(y) {
      var textArrs = ["c1", "c3", "c4", "t1", "t2"];
      return textArrs.includes(y.type) ? textArrs.includes(y.type) && (!isBlank(y.head) || !isBlank(y.paragraph)) : true;
    }
  }, {
    key: "notEmptyImage",
    value: function notEmptyImage(y) {
      return y.type.includes("c2") ? y.type.includes("c2") && !isBlank(y.imgKey) : true;
    }
  }, {
    key: "notEmptyMap",
    value: function notEmptyMap(y) {
      return y.type.includes("map") ? y.type.includes("map") && !isBlank(y.mapData.mapKey) : true;
    }
  }, {
    key: "notEmptyList",
    value: function notEmptyList(y) {
      return y.type.includes("l1") ? y.type.includes("l1") && !isBlank(y.lis) : true;
    }
  }]);
  return ViewBuilderCpWrapperUtil;
}();